const FALLBACK_ACH_INSTRUCTIONS = [
  'Guru Cultivation LLC',
  'Bank Name: Chase Bank',
  'ACH Routing: 122100024',
  'Wire Routing: 021000021',
  'Account Number: 629027753',
].join('\n');

const envInstructions = import.meta.env.VITE_INVOICE_DEFAULT_ACH_INSTRUCTIONS;

export const DEFAULT_ACH_INSTRUCTIONS =
  typeof envInstructions === 'string' && envInstructions.trim()
    ? envInstructions
    : FALLBACK_ACH_INSTRUCTIONS;
